import React from 'react';

export const ListPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { items, ordered, itemStyle } = specificAttrs || {};
  const itemsArray = (items || 'Item 1,Item 2,Item 3').split(',');
  const ListTag = ordered ? 'ol' : 'ul';
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <ListTag style={{
        margin: 0,
        paddingLeft: ordered ? '20px' : '20px',
        listStyleType: itemStyle || (ordered ? 'decimal' : 'disc')
      }}>
        {itemsArray.map((item, idx) => (
          <li key={idx} style={{ marginBottom: '4px', fontSize: '14px' }}>
            {item.trim()}
          </li>
        ))}
      </ListTag>
    </div>
  );
};
